<template>
  <div class="Textarea">
    <label v-if="label" class="Textarea__label" :for="id">{{ label }}</label>
    <textarea
      :id="id"
      class="Textarea__textBox"
      :class="{ [`Textarea__textBox--error`]: isError }"
      :name="name"
      :placeholder="placeholder"
      :rows="rows"
      :disabled="isDisabled"
      :value="value"
      @input="$emit('inputVal', $event.target.value)"
    ></textarea>
    <span v-if="isError" class="Textarea__errorText">{{ errorText }}</span>
  </div>
</template>

<script>
export default {
  name: 'TextareaBase',
  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    rows: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
    },
    isError: {
      type: Boolean,
    },
    errorText: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  emits: ['inputVal'],
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.Textarea {
  &__label {
    display: block;
    font-size: $service-font-size-p;
    font-weight: bold;
    text-align: left;
  }

  &__textBox {
    display: block;
    width: 100%;
    padding: $service-unit * 2 $service-unit * 4;
    font-family: Arial, 'Hiragino Kaku Gothic ProN', 'Hiragino Sans', sans-serif;
    font-size: $service-font-size-p;
    resize: none;
    border: 1px solid $color-gray-50;
    border-radius: $service-border-radius;

    &::placeholder {
      font-family: Arial, 'Hiragino Kaku Gothic ProN', 'Hiragino Sans',
        sans-serif;
      color: $color-gray-50;
    }

    &:hover {
      border: 1px solid $color-blue-60;
    }

    &:focus {
      outline: 2px solid $color-blue-60;
    }

    &:disabled {
      color: $color-gray-50;
      background-color: $color-gray-30;
      border: 0;
    }

    &--error {
      border: 2px solid $color-red-70;

      &:hover {
        border: 2px solid $color-red-70;
      }
    }
  }

  &__label + &__textBox {
    margin-top: $service-unit;
  }

  &__errorText {
    display: block;
    margin-top: $service-unit;
    font-size: $service-font-size-pp;
    color: $color-red-70;
    text-align: left;
  }
}
</style>
